export default "__VITE_ASSET__0df8e95f__"